import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useSelector } from 'react-redux';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { getBiContentViewStatus } from '../../DeviationPage/redux/selectors';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../types/deviation';
/** Returns correct click BI events for deviation links.
 * Please do not piggyback for other event types */ export function useBiDataForDeviationLink(deviation, extraData) {
    var _deviation_author;
    const contentViewStatus = useSelector((state)=>deviation && getBiContentViewStatus(state, deviation));
    const { needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    if (!deviation) {
        return undefined;
    }
    const typeid = getDeviationResourceType(deviation);
    const itemid = deviation.deviationId;
    const creatorid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid;
    if (typeid === DeviationResourceType.TIER) {
        return getBiDataForTierLink(deviation, extraData);
    }
    return BiData(_object_spread_props(_object_spread({
        component: BiContextProvidedValue,
        view: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        sectionname: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        rank: BiContextProvidedValue,
        sort_type: BiContextProvidedValue,
        reason_shown: BiContextProvidedValue,
        page_typeid: BiContextProvidedValue,
        page_itemid: BiContextProvidedValue
    }, extraData), {
        evid: 100,
        typeid,
        itemid,
        creatorid,
        content_view_status: needsSubscription || isSubscribedButBlocked ? 'subscription_locked' : contentViewStatus
    }));
}
export function getBiDataForTierLink(deviation, extraData) {
    if (!deviation) {
        return undefined;
    }
    const typeid = getDeviationResourceType(deviation);
    const itemid = deviation.deviationId;
    return BiData(_object_spread_props(_object_spread({
        sectionid: BiContextProvidedValue,
        sectionname: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        rank: BiContextProvidedValue
    }, extraData), {
        evid: 545,
        typeid,
        itemid
    }));
}

//# sourceMappingURL=useBiDataForDeviationLink.js.map